import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { FooterComponent } from './_templates/footer/footer.component';
import { WhyusComponent } from './_templates/whyus/whyus.component';
import { HomeComponent } from './_templates/home/home.component';
import { IntegrationComponent } from './_templates/integration/integration.component';
import { DocumentationComponent } from './_templates/documentation/documentation.component';
import { UsersComponent } from './_templates/users/users.component';
import { NavigationComponent } from './_templates/navigation/navigation.component';
import { KpisComponent } from './_templates/kpis/kpis.component';

import { httprequestService }  from './_services/httprequest.service';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    WhyusComponent,
    HomeComponent,
    IntegrationComponent,
    DocumentationComponent,
    UsersComponent,
    NavigationComponent,
    KpisComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule
  ],
  providers: [
    httprequestService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
